import { jsx as _jsx } from "react/jsx-runtime";
var PlayroomDialogFooter = function PlayroomDialogFooter(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx("div", {
    className: "tw-bg-neutral-light-300 dark:tw-bg-neutral-dark-700 tw-px-2.4 tw-py-1.6",
    children: children
  });
};
export default PlayroomDialogFooter;